module.exports = __webpack_public_path__ + "media/11.e080fe02.wav";